// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bulk-reassign-drawer .sub-heading{color:rgba(40,50,59,.54);font-size:10px;margin-left:5px;margin-top:-18px}.bulk-reassign-drawer .user-results{color:#8b9095;margin-bottom:8px;margin-top:20px}.bulk-reassign-drawer .list-group .list-group-item:hover:not(.active){background-color:#eee;cursor:pointer}.bulk-reassign-drawer .list-group .list-group-item.active{background-color:#334d62;color:#fff}", ""]);
// Exports
module.exports = exports;
